export enum HandpickChangeStatus {
    PENDING = 'PENDING',
    ERROR = 'ERROR',
    PUBLISHED = 'PUBLISHED'
}